export const calculateAllInvoicesTotal = (payments) =>
    payments.reduce((sum, payment) => sum + payment.finalAmount, 0);

export const calculateAbonoAplicado = (partialPaymentAmount) =>
    parseFloat(partialPaymentAmount) || 0;

export const calculateTotalPagarComplete = (selectedPayments, payments) =>
    selectedPayments.reduce((total, paymentId) => {
        const payment = payments.find((item) => item.id === paymentId);
        return total + (payment ? payment.finalAmount : 0);
    }, 0);

export const calculateSelectedInvoicesTotal = (selectedPayments, payments) =>
    selectedPayments.reduce((sum, paymentId) => {
        const payment = payments.find((item) => item.id === paymentId);
        return sum + (payment ? payment.finalAmount : 0);
    }, 0);

export const calculateExcess = ({
    paymentOption,
    customerType,
    partialPaymentAmount,
    selectedPayments,
    payments,
}) => {
    const abonoAplicado = calculateAbonoAplicado(partialPaymentAmount);
    if (paymentOption === 'partial' && customerType === 'M') {
        const diff = abonoAplicado - calculateSelectedInvoicesTotal(selectedPayments, payments);
        return diff > 0 ? diff : 0;
    }

    const diff = abonoAplicado - calculateAllInvoicesTotal(payments);
    return diff > 0 ? diff : 0;
};

export const calculatePendingBalanceOnlyForDisplay = (payments, appliedAmounts) =>
    payments.reduce((accumulator, payment) => {
        const { id, amount, finalAmount } = payment;
        const abonoReal = appliedAmounts[id] ?? 0;
        let leftover = 0;

        if (abonoReal >= finalAmount) {
            leftover = 0;
        } else {
            leftover = amount - abonoReal;
        }

        if (leftover < 0) {
            leftover = 0;
        }

        return accumulator + leftover;
    }, 0);
